<div
  fxLayout="row"
  fxLayoutAlign="space-between center"
  fxLayoutGap="10px"
  class="mb-5"
>
  <div>
    <ng-container *ngIf="statusPullData.nextPullAt && statusPullData.canPullStatus">
      {{ 'dialog.authorization.next-pull-at' | translate: { value: statusPullData.nextPullAt | momentDateTime } }}
    </ng-container>

    <ng-container *ngIf="statusPullData.lastPulledAt">
      {{ 'dialog.authorization.last-pull-at' | translate: { value: statusPullData.lastPulledAt | momentDateTime } }}
      <ng-container *ngIf="statusPullData.lastPulledByName">
        {{ 'dialog.authorization.last-pull-by' | translate: { value: statusPullData.lastPulledByName } }}
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!statusPullData.nextPullAt && !statusPullData.lastPulledAt">
      {{ 'dialog.authorization.no-pull-data' | translate }}
    </ng-container>
  </div>

  <div>
    <button
      *ngIf="statusPullData.canPullStatus"
      mat-stroked-button
      type="button"
      (click)="pullStatusClicked.emit()"
    >
      {{ 'dialog.authorization.pull-pre-auth' | translate }}
    </button>
  </div>
</div>
